import React, { useState } from 'react';
import Input from '../../common/Input';
import Button from '../../common/Button';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    empresa: '',
    mensagem: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const WHATSAPP_NUMBER = '5598981420180';

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const mensagemWhatsApp = `Olá! Me chamo ${formData.nome}${formData.empresa ? `, da empresa ${formData.empresa}` : ''}.

Meu e-mail é ${formData.email} e estou entrando em contato para falar sobre o seguinte:

${formData.mensagem}`;

    const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(mensagemWhatsApp)}`;
    window.open(whatsappLink, '_blank');

    setTimeout(() => {
      setFormData({
        nome: '',
        email: '',
        empresa: '',
        mensagem: ''
      });
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5 relative z-10">
      <Input
        name="nome"
        placeholder="Nome*"
        required
        value={formData.nome}
        onChange={handleChange}
        className="text-sm"
      />

      <Input
        name="email"
        type="email"
        placeholder="Seu melhor e-mail*"
        required
        value={formData.email}
        onChange={handleChange}
        className="text-sm"
      />

      <Input
        name="empresa"
        placeholder="Empresa (opcional)"
        value={formData.empresa}
        onChange={handleChange}
        className="text-sm"
      />

      <div className="w-full">
        <textarea
          name="mensagem"
          rows="5"
          placeholder="Conte-nos sobre seu projeto..."
          className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition-colors resize-none text-sm"
          value={formData.mensagem}
          onChange={handleChange}
          required
        />
      </div>

      <Button 
        type="submit" 
        variant="primary" 
        className="w-full group relative overflow-hidden"
        disabled={isSubmitting}
      >
        <span className="relative z-10">
          {isSubmitting ? 'Abrindo WhatsApp...' : 'Enviar'}
        </span>
        
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-600 to-emerald-700 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </Button>
    </form>
  );
};

export default ContactForm;